import React from 'react';
import { Link } from 'react-router-dom';


const ActivityFeedItem = (props) => {

    return (
        <div className={`kt-timeline__item ${props.type === "item_added" ? "kt-timeline__item--accent" : "kt-timeline__item--danger"}`}>
            <div className="kt-timeline__item-section">
                <div className="kt-timeline__item-section-border">
                    <div className="kt-timeline__item-section-icon">
                        {props.type === "item_added" ?
                            <i className="flaticon2-gift kt-font-success"></i>
                            : <i className="flaticon2-user kt-font-danger"></i> }
                    </div>
                </div>
                <span className="kt-timeline__item-datetime">
                    {props.name} {props.type === "item_added" 
                        ? "added a gift for " + props.target
                        : "created a gift list"
                    }</span>
            </div>
            <Link to={"/gift-list/" + props.urlcode} className="kt-timeline__item-text">
                {props.title}
            </Link>
            <div className="kt-timeline__item-info">
                {props.date}
            </div>
        </div>);
}
export default ActivityFeedItem;